import styled from '@emotion/styled';

export const StyledAllCompany = styled.div`
  width: 745px;
  height: 640px;
  border: 1px solid #e0e0e0;
  background-color: #fff;

  & > div:first-of-type {
    /* width: 100%; */
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 4px solid #7fe200;
    padding: 0 20px;

    & h3 {
      font-size: 16px;
      font-weight: 700;
      color: #333;
    }

    & span {
      font-size: 14px;
      font-weight: 400;
      color: #000;
    }
  }
`;

export const StyledHeader = styled.div`
  padding: 20px 20px 0;

  & .sendingHeader,
  & .sendingSearch {
    display: flex;
    width: 100%;
    margin-bottom: 8px;

    & > div {
      display: flex;
      justify-content: center;
      position: relative;

      & > img {
        cursor: pointer;
        position: absolute;
        right: 10px;
        top: 0;
        bottom: 0;
        margin: auto 0;

        &.searchId {
          right: 18px;
        }
      }
    }
  }

  & .sendingHeader {
    height: 23px;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 8px;
  }

  & .firstColumn {
    width: 160px;
    margin-right: 8px;
  }

  & .secondColumn {
    width: 532px;
  }
`;

export const StyledBody = styled.div`
  position: relative;
  padding: 0 20px;
  height: 480px;
  overflow-y: overlay;
  box-sizing: content-box;

  ::-webkit-scrollbar {
    width: 5px;
  }

  & > .noList {
    display: flex;
    justify-content: center;
    align-items: center;
    /* text-align: center; */
    margin-top: 28px;
  }

  & .bodyRow {
    position: relative;
    display: flex;
    align-items: center;
    width: 700px;
    height: 56px;
    border: 1px solid #999;
    border-radius: 5px;
    margin-bottom: 8px;
    padding: 0 20px;
    box-sizing: border-box;
    color: #333;
    font-size: 12px;
    font-weight: 400;

    & .td-id {
      width: 140px;
      height: 24px;
      border-right: 1px solid #e0e0e0;
    }
    & .td-company {
      margin-left: 16px;
    }
    & .td-activated {
      position: absolute;
      right: 0;
      border: 1px solid #7fe20033;
      background-color: #7fe20033;
      border-radius: 16px;
      padding: 4px;
      margin-right: 20px;
      font-weight: 700;
      font-size: 10px;
    }
  }

  & .bodyRow:hover {
    cursor: pointer;
  }
  & .selected {
    border: 2px solid #7fe200;
    font-weight: 700;

    & .td-id {
      border: initial;
      font-weight: initial;
    }
    & .td-company {
      border: initial;
      font-weight: initial;
    }
  }
`;
